// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon___2XL7I","wrapper":"wrapper___3fIMs","active":"active___2qGqx"};